import { useAsyncEffect } from '@xylabs/sdk-react'
import { Quadkey, XyoWorldAuction } from '@xyo-network/sdk-xyoworld-js'
import { useContext, useState } from 'react'

import useMinter from '../useMinter'
import { MinterAuctionContext } from './Context'

export const useAuction = (quadkey?: Quadkey | null, load = false) => {
  const [auction, setAuction] = useState<XyoWorldAuction>()
  const [refreshCount, setRefreshCount] = useState(0)
  const { minter } = useMinter()
  const [reload, setReload] = useState(load ?? false)
  const auctionContext = useContext(MinterAuctionContext)

  const quadKeyToUse = quadkey ?? auctionContext.quadkey ?? auctionContext.auction?.quadkey

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      let data
      if (quadKeyToUse) {
        data = minter?.auctions().get(quadKeyToUse)
        setAuction(undefined)
        if (reload) {
          await data?.refresh()
        }
      }
      if (isMounted()) {
        setAuction(data)
      }
    },
    [quadKeyToUse, minter, refreshCount, load, reload],
  )

  const refresh = () => {
    setReload(true)
    setRefreshCount(refreshCount + 1)
  }

  return { auction, refresh }
}
